import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';
var INITIAL_STATE = {
  isModalOpen: false,
  itemId: '',
  skuId: '',
  productId: '',
  fulfillmentType: 'SHIP',
  showPickupIneligibleMessage: false
};
var createShopDialogStore = function createShopDialogStore() {
  return createStore(devtools(function (set) {
    return _objectSpread(_objectSpread({}, INITIAL_STATE), {}, {
      openDialog: function openDialog() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          itemId = _ref.itemId,
          skuId = _ref.skuId,
          productId = _ref.productId,
          _ref$fulfillmentType = _ref.fulfillmentType,
          fulfillmentType = _ref$fulfillmentType === void 0 ? 'SHIP' : _ref$fulfillmentType,
          showPickupIneligibleMessage = _ref.showPickupIneligibleMessage;
        return set({
          itemId: itemId,
          skuId: skuId,
          productId: productId,
          fulfillmentType: fulfillmentType,
          showPickupIneligibleMessage: showPickupIneligibleMessage,
          isModalOpen: true
        });
      },
      closeDialog: function closeDialog(payload) {
        return set(function (state) {
          return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
            isModalOpen: false
          });
        });
      },
      toggleDialog: function toggleDialog(payload) {
        return set(function (state) {
          if (state.isModalOpen) {
            return _objectSpread(_objectSpread(_objectSpread({}, state), payload), {}, {
              isModalOpen: false
            });
          }
          return {
            itemId: payload === null || payload === void 0 ? void 0 : payload.itemId,
            skuId: payload === null || payload === void 0 ? void 0 : payload.skuId,
            productId: payload === null || payload === void 0 ? void 0 : payload.productId,
            fulfillmentType: (payload === null || payload === void 0 ? void 0 : payload.fulfillmentType) || 'SHIP',
            showPickupIneligibleMessage: payload === null || payload === void 0 ? void 0 : payload.showPickupIneligibleMessage,
            isModalOpen: true
          };
        });
      }
    });
  }, {
    name: 'NikeShop - Shop Dialog',
    enabled: process.env.NODE_ENV === 'development'
  }));
};
export default createShopDialogStore;